const getScrollableParent = (element: HTMLElement): HTMLElement | null => {
  let current = element.parentElement;
  while (current) {
    const { overflow, overflowY } = window.getComputedStyle(current);
    if (/(auto|scroll)/.test(overflow + overflowY)) {
      return current;
    }
    current = current.parentElement;
  }
  return document.documentElement;
};

const scrollToTarget = (
  element: HTMLElement,
  target: number,
  duration = 600,
) => {
  const start = element.scrollTop;
  const distance = target - start;
  const startTime = performance.now();

  const step = (currentTime: number) => {
    const elapsed = currentTime - startTime;
    const progress = Math.min(elapsed / duration, 1);
    const ease = progress * (2 - progress); // ease-out quadratic
    element.scrollTop = start + distance * ease;
    if (progress < 1) {
      requestAnimationFrame(step);
    }
  };

  requestAnimationFrame(step);
};

export const smoothScrollTo = (element: HTMLElement, duration = 600) => {
  const scrollableParent = getScrollableParent(element);
  if (scrollableParent) {
    const parentRect = scrollableParent.getBoundingClientRect();
    const elementRect = element.getBoundingClientRect();
    const offset =
      elementRect.top - parentRect.top + scrollableParent.scrollTop;
    scrollToTarget(scrollableParent, offset, duration);
  }
};
